module.exports = __webpack_public_path__ + "static/img/产品中心-AI设备专家-设备管理.46189bba.jpg";